import Vue from "vue";

import DirectoryUploader from "./DirectoryUploader.vue";

export default class AsdS3Directory {

    static init() {

        // this.saveButton = document.getElementById('savebutton');
        // this.saveButton.type = 'button';
        // this.saveButton.addEventListener('click', this.testMethod);

        let elements = document.querySelectorAll('.asd-s3-directory-manager');
        elements.forEach( x => {
            let rawData = x.getAttribute('data-directory');
            if (rawData === '' || !rawData) {
                console.log('Cannot instantiate: empty data', x);
                return;
            }

            let data;
            try {
                data = JSON.parse(rawData);

                console.log('AsdDirs will init with',data);
            }
            catch (e) {
                console.log('Cannot parse data', rawData, x);
                return;
            }

            Vue.component('DirectoryUploader', DirectoryUploader);

            let component = Vue.extend(DirectoryUploader);
            new component({
                el: x,
                propsData: {
                    files: data.files,
                    entity_id: parseInt(data.entity_id),
                    uploadEnabled: data.uploadEnabled
                },
            });

        })
    }
}
